import React from 'react';
import PropTypes from 'prop-types';
import { uppercaseUnderscore } from '../../utils/stringConversion';
import * as colors from './ItemColors';
import Button from '../Global/Buttons/Button';
import Icon from '../Global/Icons/Icon';

const ItemColorSelect = ({ activeColor, changeColor }) => {
  const itemColors = [`green`, `blue`, `yellow`, `red`, `black`, `grey`, `white`];

  return (
    <ul className="color-select">
      {itemColors.map((color) => {
        const colorFormatted = uppercaseUnderscore(color);

        return (
          <li key={color} className={color}>
            <Button style={{ backgroundColor: colors[colorFormatted] }} onClick={e => changeColor(e, colors[colorFormatted])} faux>
              {/* Have to have null as the else here to make sure the button component doesn't complain about a boolean children prop type */}
              {activeColor === colors[colorFormatted] ? (
                <Icon name="tick" size="m" fill="white" />
              ) : (
                null
              )}
            </Button>
          </li>
        );
      })}
    </ul>
  );
};

ItemColorSelect.propTypes = {
  activeColor: PropTypes.string,
  changeColor: PropTypes.func,
};

export default ItemColorSelect;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/ItemColorSelect.js